$(function() {

    var $grid;

    var blogCreateIsotope = function() {
        if (!isBreakpoint('xs') && !isBreakpoint('sm')) {
            $grid = $(".isotope-grid").isotope({
                itemSelector: '.grid-item',
            });
        }
    };

    var isBreakpoint = function(alias) {
        return $('.device-' + alias).is(':visible');
    };

    blogCreateIsotope();

    $('#content').on('click', '.blog-categories button.category', function() {

        if (!$(this).hasClass("active")) {
            // bei allen Elementen die Klasse "active" entfernen
            $('.blog-categories button.category').removeClass('active');
            $(this).addClass('active');
            $(this).attr("aria-pressed", true);
            var cat = $(this).val();
            $grid.isotope({ filter: '.cat-'+cat });
        } else {
            $(this).removeClass('active');
            $(this).attr("aria-pressed", false);
            $grid.isotope({ filter: '*' });
        }

        var filteredItems = $grid.isotope('getFilteredItemElements');
        $("#number").text(filteredItems.length);

    });

});